<template>
  <v-container fluid>
    <v-row>
      <v-col md="6" cols="12">
        <div class="conOfHeader">
          <div class="headerOfPage">Currency</div>
        </div>
      </v-col>
      <v-col md="6" cols="12">
        <div class="conOfHeader text-right">
          <div class="btnAdd">
            <v-btn class="btnAddPrimary" @click="dialogProject = true">
              <v-icon>mdi-plus</v-icon>
              Create New
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="listData && listData.length > 0">
      <v-col cols="12">
        <section class="conOfProjects">
          <div class="conOfTable">
            <v-data-table
              :headers="headers"
              :items="listData"
              :items-per-page="10"
              hide-default-footer
            >
              <template v-slot:[`item.actions`]="{ item }">
                <v-menu bottom :left="true" :offset-y="true">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn dark icon v-bind="attrs" v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item @click="editItem(item)">
                      <v-list-item-title class="statusTxt">
                        Edit
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
              <template v-slot:[`item.created_at`]="{ item }">
                <div>{{ item.created_at | formatDate }}</div>
              </template>
            </v-data-table>
          </div>
        </section>
        <div
          class="conOfPagination pr-5 pt-5"
          v-if="pagination.total > pagination.per_page"
        >
          <v-pagination
            :total-visible="7"
            v-model="pagination.current_page"
            :length="pagination.last_page"
            @input="goToPage(pagination.current_page)"
          ></v-pagination>
        </div>
      </v-col>
    </v-row>
    <div class="loaderContainer" v-else-if="isLoading">
      <v-progress-circular
        :size="120"
        :width="4"
        indeterminate
        color="primary"
      ></v-progress-circular>
    </div>
    <v-row v-else>
      <v-col cols="12" class="mt-7">
        <EmptyState />
      </v-col>
    </v-row>
    <v-snackbar
      v-model="successSnackbar"
      color="success"
      shaped
      absolute
      top
      right
      :timeout="timeout"
    >
      {{ successMessage }}
    </v-snackbar>
    <v-snackbar
      v-model="errorSnackbar"
      color="red"
      shaped
      top
      right
      :timeout="timeout"
    >
      {{ errorMessage }}
    </v-snackbar>
    <v-dialog scrollable v-model="dialogProject" max-width="500">
      <v-card class="conOfPopup">
        <v-card-title>
          <span class="text-h5 callbacks modalTitle">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text class="conFormSubmit scrollbar">
          <v-container>
            <v-row>
              <v-col cols="12">
                <label class="eachLabel">Role Name</label>
                <v-text-field
                  class="eachInput"
                  placeholder="Team Name"
                  outlined
                  solo
                  hide-details="auto"
                  v-model="formItem.name"
                  required
                  :error-messages="nameErrors"
                  @input="$v.formItem.name.$touch()"
                  @blur="$v.formItem.name.$touch()"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="pb-10">
          <v-spacer></v-spacer>
          <v-btn class="btnCancel" tile @click="closeProjectModal">
            Cancel
          </v-btn>
          <v-btn
            class="btnPrimaryOrg"
            @click="saveItem"
            :disabled="isLoadingSave"
            :loading="isLoadingSave"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { ApiService } from "@/modules/shared/services/api";
let apiServices = new ApiService();
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import EmptyState from "@/modules/shared/components/emptystate";
import { mapGetters } from "vuex";
export default {
  mixins: [validationMixin],
  validations() {
    const validations = {
      formItem: {
        name: { required },
      },
    };
    return validations;
  },
  data: () => ({
    successSnackbar: false,
    errorSnackbar: false,
    timeout: 3000,
    dialogProject: false,
    isLoadingSave: false,
    isLoading: false,
    editedIndex: -1,
    pagination: {
      current_page: 1,
    },
    formItem: {},
    defaultItem: {},
    headers: [
      {
        text: "CURRENCY",
        align: "start",
        value: "name",
        sortable: false,
      },
      { text: "CREATE DATE", value: "created_at" },
      { text: "", value: "actions", sortable: false, align: "right" },
    ],
    listData: [],
  }),
  components: { EmptyState },
  computed: {
    ...mapGetters(["apiMessage"]),
    formTitle() {
      return this.editedIndex === -1 ? "Add New Currency" : "Edit Currency";
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.formItem.name.$dirty) return errors;
      !this.$v.formItem.name.required &&
        errors.push("Currency Name Is Required.");
      return errors;
    },
  },
  methods: {
    editItem(item) {
      this.editedIndex = item.id;
      let editFormItem = {
        name: item.name,
      };
      this.formItem = editFormItem;
      this.dialogProject = true;
    },
    itemEdited() {
      this.$v.$touch();
      if (this.$v.$error) return;
      this.isLoadingSave = true;

      apiServices
        .update(this.editedIndex, "currencies", this.formItem)
        .then((res) => {
          if (res) {
            this.successMessage = res.message || "Successful";
            this.successSnackbar = true;

            this.pagination.current_page = 1;
            this.getListData(this.pagination.current_page);
            this.isLoadingSave = false;
            this.closeProjectModal();
          } else {
            this.isLoadingSave = false;
            let errors = Object.values(this.apiMessage)[0];
            errors.forEach((err) => {
              this.errorMessage = err;
            });
            this.errorSnackbar = true;
          }
        });
    },
    itemAddNew() {
      this.$v.$touch();
      if (this.$v.$error) return;
      this.isLoadingSave = true;

      apiServices.post("currencies", this.formItem).then((res) => {
        if (res) {
          this.successMessage = res.message || "Successful";
          this.successSnackbar = true;

          this.pagination.current_page = 1;
          this.getListData(this.pagination.current_page);
          this.isLoadingSave = false;
          this.closeProjectModal();
        } else {
          this.isLoadingSave = false;
          let errors = Object.values(this.apiMessage)[0];
          errors.forEach((err) => {
            this.errorMessage = err;
          });
          this.errorSnackbar = true;
        }
      });
    },
    saveItem() {
      if (this.editedIndex > -1) {
        this.itemEdited();
      } else {
        this.itemAddNew();
      }
    },
    closeProjectModal() {
      this.editedIndex = -1;
      this.dialogProject = false;
      this.$nextTick(() => {
        this.$v.$reset();
        this.formItem = Object.assign({}, this.defaultItem);
      });
    },
    goToPage(page) {
      this.getListData(page);
      window.scrollTo(0, 0);
    },
    getListData(page) {
      this.listData = [];
      this.isLoading = true;
      apiServices.get(`currencies?per_page=7&page=${page}`).then((res) => {
        if (res) {
          this.listData = res.data;
          this.pagination = res.meta;
          this.isLoading = false;
        } else this.isLoading = false;
      });
    },
  },
  created() {
    this.getListData(this.pagination.current_page);
  },
  watch: {
    dialogProject(val) {
      val || this.closeProjectModal();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./_currency.scss";
</style>
